import React, { useState } from 'react'
import CONSTANTS from '../../../../util/constant/CONSTANTS'
import CRUDComponent from '../../../../component/common/CRUD-Component'
import { Button, Card, Modal, QRCode, Row } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { COPY_UNIQUE_ID, DEVICE, DEVICE_CONNECTION, DEVICE_STATUS, apiGenerator } from '../../../../util/functions'
import moment from 'moment'
import Heading from '../../../../component/common/Heading'
import { role } from '../../../../util/Route'

const Pets = () => {
    const [qrData, setQrData] = useState(null)
    const { id } = useParams()
    const navigate = useNavigate()

    const userPetApi = apiGenerator(CONSTANTS.API.Pet.getAll, {}, `?userId=${id}`)

    const downloadQRCode = async () => {
        const canvas = document.getElementById('myqrcode')?.querySelector('canvas');

        if (canvas) {
            // Wait for the QR code to render
            await new Promise(resolve => setTimeout(resolve, 500)); // Adjust the delay as needed

            const url = canvas.toDataURL();
            const a = document.createElement('a');
            a.download = 'QRCode.png';
            a.href = url;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    };


    // console.log(userFeedBackApi);
    return (
        <>
            <Card>
                <Heading>Pets</Heading>

                <Row>
                    <CRUDComponent
                        GET={{
                            API: userPetApi,
                            DataModifier: (res, API, Setrefresh) => {
                                // console.log(res, "GET ALL ABCD");
                                return res?.map(data => {
                                    return {
                                        ...data,
                                        no: `P${data?.id.toString().padStart(7, "0")}`,
                                        dob: moment(data?.dob).format("DD MMM YYYY"),
                                        isBlocked: {
                                            checked: !data?.isBlock,
                                            id: data?.id,
                                            onClick: (id, val) => {
                                                const UpdateAPIEnd = { ...CONSTANTS?.API.Pet.update };
                                                UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${id}`;
                                                API.sendRequest(
                                                    UpdateAPIEnd,
                                                    () => {
                                                        Setrefresh((prev) => !prev);
                                                    },
                                                    { isBlock: val },
                                                    `Pet ${val ? "Blocked" : "Unblocked"} Successfully`
                                                );
                                            },
                                            // onClick: () => { }
                                        },
                                        view: {
                                            id: data?.id,
                                            onClick: () => {
                                                navigate(`/app/pets/${data?.id}`)
                                            }
                                        },

                                        // Device
                                        deviceTypeId: data?.petDevices?.length > 0 ? DEVICE[data?.petDevices[0]?.device?.deviceTypeId] : (data?.petDeviceInfos?.length > 0 ? DEVICE[data?.petDeviceInfos[0]?.device?.deviceTypeId] : '-'),
                                        deviceStatus: data?.petDevices?.length > 0 ? DEVICE_STATUS[data?.petDevices[0]?.device?.isActive] : (data?.petDeviceInfos?.length > 0 ? DEVICE_STATUS[data?.petDeviceInfos[0]?.device?.isActive] : '-'),
                                        Did: data?.petDevices?.length > 0 ? data?.petDevices[0]?.device?.DID : (data?.petDeviceInfos?.length > 0 ? data?.petDeviceInfos[0]?.device?.DID : '-'),
                                        deviceQR: data?.petDevices?.length > 0 ? DEVICE_CONNECTION[true] : ((data?.petDeviceInfos?.length > 0) ? (data?.petDeviceInfos[0]?.scanQr ? DEVICE_CONNECTION[true] : DEVICE_CONNECTION[false]) : '-'),
                                        deviceWifi: data?.petDevices?.length > 0 ? DEVICE_CONNECTION[true] : ((data?.petDeviceInfos?.length > 0) ? (data?.petDeviceInfos[0]?.connectWifi ? DEVICE_CONNECTION[true] : DEVICE_CONNECTION[false]) : '-'),
                                        deviceConnection: data?.petDevices?.length > 0 ? 'Connected' : 'Not Connected',
                                        collarId: data?.petDevices?.length > 0 ? COPY_UNIQUE_ID(data?.petDevices[0]?.device?.uniqueId) : ((data?.petDeviceInfos?.length > 0) ? COPY_UNIQUE_ID(data?.petDeviceInfos[0]?.device?.uniqueId) : '-'),
                                        qrcode: {
                                            id: data?.id,
                                            onClick: () => {
                                                setQrData({
                                                    collarId: data?.petDevices[0]?.device?.uniqueId,
                                                })
                                            }
                                        },


                                        // Feeder Device
                                        feederStatus: data?.feederConnections?.length > 0 ? DEVICE_STATUS[data?.feederConnections[0]?.feedar?.isActive] : (data?.feederDeviceInfos?.length > 0 ? DEVICE_STATUS[data?.feederDeviceInfos[0]?.feedar?.isActive] : '-'),
                                        feederQR: data?.feederConnections?.length > 0 ? DEVICE_CONNECTION[true] : ((data?.feederDeviceInfos?.length > 0) ? (data?.feederDeviceInfos[0]?.scanQr ? DEVICE_CONNECTION[true] : DEVICE_CONNECTION[false]) : '-'),
                                        feederWifi: data?.feederConnections?.length > 0 ? DEVICE_CONNECTION[true] : ((data?.feederDeviceInfos?.length > 0) ? (data?.feederDeviceInfos[0]?.connectWifi ? DEVICE_CONNECTION[true] : DEVICE_CONNECTION[false]) : '-'),
                                        feederId: data?.feederConnections?.length > 0 ? COPY_UNIQUE_ID(data?.feederConnections[0]?.feedar?.uniqueId) : ((data?.feederDeviceInfos?.length > 0) ? COPY_UNIQUE_ID(data?.feederDeviceInfos[0]?.feedar?.uniqueId) : '-'),
                                        feederConnection: data?.feederConnections?.length > 0 ? 'Connected' : 'Not Connected',
                                    }
                                })
                            },
                            column: role === 'Admin' ? CONSTANTS.TABLE.USER_PETS : CONSTANTS.TABLE.SUPPORT_USER_PETS,
                        }}
                        isSearch={true}

                    />
                </Row>
                <Modal
                    open={qrData !== null}
                    title={<p className="form-modal-head mb25">Generate QR Code</p>}
                    okText="Submit"
                    centered
                    cancelButtonProps={{ style: { display: "none" } }}
                    okButtonProps={{ style: { display: "none" } }}
                    className="form-modal-title"
                    onCancel={() => setQrData(null)}
                    onOk={() => setQrData(null)}
                >
                    <div className='flex flex-col justify-center items-center ' >
                        <div id="myqrcode">
                            <QRCode

                                value={JSON.stringify({
                                    collarId: qrData?.collarId?.toString(),
                                })}
                                bgColor="#fff"
                                style={{
                                    marginBottom: 16,
                                }}
                            />
                        </div>
                        <Button type="primary" onClick={downloadQRCode}>
                            Download
                        </Button>

                    </div>
                </Modal>

            </Card>
        </>
    )
}

export default Pets